import React from "react";

import OverviewIcon from "@uui/List";
import SourcesIcon from "@uui/MessageNotificationSquare";
import NotesIcon from "@uui/Stars02";
import { findIndex } from "lodash/fp";

import type { TopicReportTab } from "@app/analytics/TopicReport/types";

import { Container, Navigation, NavigationButton } from "./styles";

interface FooterTab {
  label: string;
  value: TopicReportTab;
  icon: React.ReactNode;
}

const TABS: FooterTab[] = [
  {
    label: "Notes & Timeline",
    value: "notes",
    icon: <NotesIcon />,
  },
  {
    label: "Overview",
    value: "overview",
    icon: <OverviewIcon />,
  },
  {
    label: "Sources",
    value: "sources",
    icon: <SourcesIcon />,
  },
];

const FooterNavigation = ({
  onChange,
  selected,
}: {
  onChange: (tab: TopicReportTab) => void;
  selected: TopicReportTab;
}) => {
  const selectedValue = Math.max(0, findIndex({ value: selected }, TABS));
  const handleChangeTab = (event: React.SyntheticEvent, index: number) =>
    onChange(TABS[index].value);

  return (
    <Container>
      <Navigation showLabels value={selectedValue} onChange={handleChangeTab}>
        {TABS.map((tab) => (
          <NavigationButton key={tab.value} icon={tab.icon} label={tab.label} />
        ))}
      </Navigation>
    </Container>
  );
};

export default FooterNavigation;
